var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn txt-btn uppercase",attrs:{"id":"EXIT","name":"EXIT","data-vcode":"EXIT"}},[_vm._v(" "+_vm._s(_vm.$t('exitButton'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }